import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_cuenta`);
  return response;
};

const getList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_cuenta/get/list`);
  return response;
};

const getAllComplete = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_cuenta/get/all`);
  return response;
};

const getAllActive = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_cuenta/get/active`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_cuenta/${id}`);
  return response;
};

const getByOdooId = async (odooId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_cuenta/odoo/${odooId}`);
  return response;
};

const getByCode = async (code) => {
  const response = await get(`${process.env.REACT_APP_SERVER}odoo_cuenta/code/${code}`);
  return response;
};

const createManual = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}odoo_cuenta/manual/crear`, payload);
  return response;
};

const updateManual = async (id, payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}odoo_cuenta/manual/${id}`, payload);
  return response;
};

const deleteManual = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}odoo_cuenta/manual/${id}`);
  return response;
};

export {getAll, getList, getAllComplete, getAllActive, getById, getByOdooId, getByCode, createManual, updateManual, deleteManual};